/* eslint-disable camelcase */
import React from 'react';
import { CATEGORIES_ORDER, CATEGORY_MOST_INTRESTING_TAG_ID } from 'app/const/categories';
import { selectDishes } from 'app/utils/dish';

export const getDishesHashSum = (arr) => {
    let res = 0;
    arr.forEach((itm) => {
        res += (Number(itm.id) + Number(itm.price));
    });
    return res;
};

export const getDishesByC_ID = (dishes, c_ID, excludeList) => {
    const menuDishes = dishes.filter((d) => {
        const isSameCategories = String(d.categoryId) === c_ID;
        const isNotFromInteresting = !excludeList.includes(d.id);
        return isSameCategories && isNotFromInteresting;
    });
    return menuDishes || [];
};

export const useFlatDishesList = (props) => {
    const {
        menuDishesQuery: { menuDishes, filtredDishes },
        selectedFilters: {
            selectedCategories,
            selectedTags,
        },
    } = props;

    const ENABLED_CATEGORIES_ORDER = CATEGORIES_ORDER.filter((c) => selectedCategories.includes(c));

    const dishesHashSum = getDishesHashSum(filtredDishes);

    const intrstDishes = {
        menuDishes: selectDishes(
            menuDishes,
            null,
            [CATEGORY_MOST_INTRESTING_TAG_ID, ...selectedTags],
            selectedCategories,
        ),
    };

    const intrstDishesIdList = intrstDishes?.menuDishes.map((itm) => String(itm.id));

    const intrstDishesSimpleList = intrstDishes?.menuDishes.map((itm) => ({
        categoryId: String(itm.categoryId),
        id: itm.id,
    }));

    const intrst = [...intrstDishesSimpleList].map((itm) => ({
        categoryId: intrstDishesIdList.includes(itm.id) ? '0' : String(itm.categoryId),
        id: itm.id,
    }));

    const other = ENABLED_CATEGORIES_ORDER.reduce((acc, c_ID) => {
        const dishes = getDishesByC_ID(menuDishes, c_ID, intrstDishesIdList);
        return [...acc, ...dishes];
    }, []);

    const flatDishesList = [...intrst, ...other].map((itm) => ({
        categoryId: itm.categoryId,
        id: itm.id,
        availableStatus: itm.availableStatus,
    }));

    return { flatDishesList, dishesHashSum, intrstDishesIdList };
};
